import { Component, Inject } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiModule } from '../../../../ui/ui.module';
import { ViewEncapsulation } from '@angular/core';
import { ICustomer, ILocation } from '../../../customers/models/customers.models';
import { CompanyLocationResult, CompanyLocationSelectorComponent } from '../company-location-selector/company-location-selector.component';

type DialogStep = 'company' | 'location' | 'create';

/**
 * Thin MatDialog wrapper around {@link CompanyLocationSelectorComponent}. It bridges the dialog's
 * injected data to the selector's inputs and forwards the selector results to `dialogRef.close()`,
 * so existing modal call sites keep working unchanged.
 */
@Component({
  selector: 'app-companies-selection-dialog',
  imports: [SharedModule, UiModule, CompanyLocationSelectorComponent],
  standalone: true,
  templateUrl: './companies-selection-dialog.component.html',
  styleUrls: ['./companies-selection-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CompaniesSelectionDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ILocation>,
    @Inject(MAT_DIALOG_DATA) public data: {
      company: ICustomer | null,
      location?: ILocation | null,
      canGoBack?: boolean,
      mode?: 'new' | 'edit',
      order_id?: number,
      targetId?: number,
      initialStep?: DialogStep,
      prefillLocation?: { apartment?: string },
    } | null,
  ) {}

  onCompleted(result: CompanyLocationResult): void {
    this.dialogRef.close(result);
  }

  onCancelled(): void {
    this.dialogRef.close();
  }
}
